export { Hero, Props as HeroProps } from "./hero";
